import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import { API_URL, getAuthHeader } from '@/lib/utils';
import { Save, Loader2, Link2 } from 'lucide-react';

const AdminEMRPlans = () => {
  const [apiUrl, setApiUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/settings`, { headers: getAuthHeader() });
        setApiUrl(res.data.emr_plans_api_url || '');
      } catch (error) {
        toast.error('Failed to load settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await axios.get(`${API_URL}/settings`, { headers: getAuthHeader() });
      const settings = res.data;
      settings.emr_plans_api_url = apiUrl;
      await axios.put(`${API_URL}/settings`, settings, { headers: getAuthHeader() });
      toast.success('API URL saved successfully');
    } catch (error) {
      toast.error('Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-center py-12 text-gray-500">Loading...</div>;
  }

  return (
    <div data-testid="admin-emr-plans">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1a2a5e] font-manrope">EMR & HIS Plans</h1>
        <p className="text-gray-500 text-sm mt-1">Configure your external API to display EMR/HIS plans on the website</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg text-[#1a2a5e] flex items-center gap-2">
            <Link2 size={20} />
            Plans API Configuration
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>API URL</Label>
            <Input
              value={apiUrl}
              onChange={(e) => setApiUrl(e.target.value)}
              placeholder="https://api.stewardindia.com/v1/plans"
              data-testid="emr-api-url-input"
            />
            <p className="text-xs text-gray-400">Enter the API endpoint that returns your EMR/HIS plans. The EMR/HIS page will fetch and display plans from this URL.</p>
          </div>
          <Button
            onClick={handleSave}
            disabled={saving}
            className="bg-[#1a2a5e] hover:bg-[#2d4a8e]"
            data-testid="save-api-btn"
          >
            {saving ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Save size={16} className="mr-2" />}
            Save API URL
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminEMRPlans;
